/**
 * ComingSoonModal — the shell's one message surface (§7.M7 / §7.10): what a
 * gated control says instead of doing nothing, and how filing, deleting and
 * other taps report an outcome or failure. "Got it" or the scrim closes it.
 */

import { Modal } from "./Modal";
import { PillButton } from "./PillButton";

export interface ComingSoonModalProps {
  message: string;
  onClose: () => void;
}

export function ComingSoonModal({ message, onClose }: ComingSoonModalProps) {
  return (
    <Modal
      testid="coming-soon-modal"
      dialog
      zIndex={30}
      scrim={70}
      padding="24px"
      onClose={onClose}
      card={{ width: "300px", padding: "24px", gap: "16px" }}
    >
      <span data-testid="coming-soon-message" style={{ fontSize: "14px", color: "var(--mark-text-primary)", lineHeight: 1.5 }}>
        {message}
      </span>
      <PillButton size="sm" data-testid="coming-soon-dismiss" onClick={onClose}>
        Got it
      </PillButton>
    </Modal>
  );
}
